namespace Matrix.DataAudit {
    export interface AccountHistoryRow {
        AccountKey?: number;
        AccountCode?: string;
        Name?: string;
        Generation?: number;
        IsCurrent?: string;
        DateFrom?: string;
        DateTo?: string;
        CurrentFrom?: string;
        CurrentTo?: string;
        AccountTypeCode?: string;
        AccountTypeName?: string;
        AccountRoleCode?: string;
        AccountRoleName?: string;
        ManagerCode?: string;
        ManagerName?: string;
        BaseCurrencyCode?: string;
        AssetClass?: string;
        Benchmark1?: string;
        Benchmark2?: string;
        InceptionDate?: string;
        TerminationDate?: string;
        InvestmentObjective?: string;
        PerformanceBenchmark1?: string;
        PerformanceBenchmark2?: string;
        PerformanceInceptionDate?: string;
        PerformanceTerminationDate?: string;
        Status?: string;
        RowId?: number;
        Version?: number;
        SourceCreatedBy?: string;
        SourceCreatedWhen?: string;
        SourceUpdatedBy?: string;
        SourceUpdatedWhen?: string;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace AccountHistoryRow {
        export const idProperty = 'AccountKey';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'DataAudit.AccountHistory';
        export const deletePermission = 'Read:AccountHistory';
        export const insertPermission = 'DataAdmin:AccountHistory';
        export const readPermission = 'Read:AccountHistory';
        export const updatePermission = 'NoPermission';

        export declare const enum Fields {
            AccountKey = "AccountKey",
            AccountCode = "AccountCode",
            Name = "Name",
            Generation = "Generation",
            IsCurrent = "IsCurrent",
            DateFrom = "DateFrom",
            DateTo = "DateTo",
            CurrentFrom = "CurrentFrom",
            CurrentTo = "CurrentTo",
            AccountTypeCode = "AccountTypeCode",
            AccountTypeName = "AccountTypeName",
            AccountRoleCode = "AccountRoleCode",
            AccountRoleName = "AccountRoleName",
            ManagerCode = "ManagerCode",
            ManagerName = "ManagerName",
            BaseCurrencyCode = "BaseCurrencyCode",
            AssetClass = "AssetClass",
            Benchmark1 = "Benchmark1",
            Benchmark2 = "Benchmark2",
            InceptionDate = "InceptionDate",
            TerminationDate = "TerminationDate",
            InvestmentObjective = "InvestmentObjective",
            PerformanceBenchmark1 = "PerformanceBenchmark1",
            PerformanceBenchmark2 = "PerformanceBenchmark2",
            PerformanceInceptionDate = "PerformanceInceptionDate",
            PerformanceTerminationDate = "PerformanceTerminationDate",
            Status = "Status",
            RowId = "RowId",
            Version = "Version",
            SourceCreatedBy = "SourceCreatedBy",
            SourceCreatedWhen = "SourceCreatedWhen",
            SourceUpdatedBy = "SourceUpdatedBy",
            SourceUpdatedWhen = "SourceUpdatedWhen",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
